<template>
  <v-menu 
    top
    offset-y
    content-class="qmkey-explorer-table-menu-contents"
  >
    <template v-slot:activator="{ attrs, on }">
        <v-icon
          small
          icon
          class="mr-2"
          v-on="on"
          v-bind="attrs"
        >
          mdi-home-export-outline
        </v-icon>
    </template>
    <v-list dense>
      <v-list-item
        v-for="action in actions"
        :key="action.id"
        @click.stop="action_transition(action, site)"            
      >
        <v-list-item-icon>
          <v-icon
            v-text="action.icon"
            small
          >
          </v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ action.label }}</v-list-item-title>        
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import ViewTitle from '@/components/ViewTitle'
import EmpresaImportExport from '@/api/EmpresaImportExport'
import ModalDialogForm from '@/components/explorer/ModalDialog'
import { downloadFile } from '@/utils/browserfiles';
import { InfoAlert, SuccessAlert, ErrorAlert } from '@/utils/Alerts'

export default {
  name: 'ExportSiteActions',
  components: {
    ViewTitle,
    ModalDialogForm,
  },
  props: {
    site: {
      type: Object,
      required: true
    },
  },

  data: () => ({
    actions: [
      {
        "id": "export-pakage",
        "label": "Export to pakage",
        "icon": "mdi-package-down",
      },
      {
        "id": "export-excel",
        "label": "Export to excel",
        "icon": "mdi-file-excel",
      },
      {
        "id": "advanced-export-excel",
        "label": "Advanced Export to excel",
        "icon": "mdi-arrange-send-backward",
      },
    ]
  }),
  computed: {
  },

  methods: {
    action_transition(action, item) {
      this.$emit(action.id, item);
    },

    toggle_dialog() {
      this.showModalDialog = false;
      this.modalTitle = ``;
      this.fields_to_collect = [];
      this.submit_action = (()=>{});
      this.submit_button_caption = '';
    },
  },

  mounted() {
  },

}
</script>


<style lang="scss">
@import "@/sass/menus.scss";
@import "@/sass/explorer.scss";
</style>